import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'updateHistory'
})
export class UpdateHistoryPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (value && value?.length > 0) {
            const firstName = value[value?.length - 1]?.firstName === null ? '' : value[value?.length - 1]?.firstName;
            const lastName = value[value?.length - 1]?.lastName === null ? '' : value[value?.length - 1]?.lastName;
            if (firstName && lastName) {
                return firstName + ' ' + lastName;
            }

            if (value[value?.length - 1]?.name !== null) {
                return value[value?.length - 1]?.name;
            }

        }
        return '';
    }

}
